<tlk-embedded-remote-application [hidden]="!appLoaded" [appId]="appId" [appParameters]="appParameters" />
<div class="implants-view-loading-container" *ngIf="!appLoaded">
	<tlk-loading-spinner></tlk-loading-spinner>
</div>
